//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  signal,
  WritableSignal,
} from "@angular/core";


//local imports
import { Messenger, PresenterType } from "@app/shared";
import { CatalogSubMenuModel } from "@app/catalog";

@PresenterType({
  model: CatalogSubMenuModel,
  key: "subMenu"
})
@Component({
  selector: "catalog-sub-menu",
  templateUrl: "./catalog-sub-menu.component.html",
  styleUrl: "./catalog-sub-menu.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CatalogSubMenuComponent implements OnDestroy {
  public data: WritableSignal<CatalogSubMenuModel> = signal<CatalogSubMenuModel>(null);


  constructor(private messenger: Messenger) {
  }

  ngOnDestroy() {
    this.messenger.unsubscribeByOwner(this);
  }
}
